import React from "react";
import ReactDOM from "react-dom";
import "./Style/style.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { createStore } from "redux";
import { persistStore } from "redux-persist";
import AppReducer from "./Redux/Reducers";
import { PersistGate } from "redux-persist/integration/react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const store = createStore(AppReducer);
const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register(toast);
